"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.solanaDescribePath = solanaDescribePath;
exports.solanaGetAccountPaths = solanaGetAccountPaths;
exports.solanaAddressNListToBIP32 = solanaAddressNListToBIP32;
exports.solanaBuildTransaction = solanaBuildTransaction;
const web3_js_1 = require("@solana/web3.js");
const utils_1 = require("./utils");
function solanaDescribePath(path) {
    const pathStr = (0, utils_1.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Solana",
        isKnown: false,
    };
    if (path.length != 4)
        return unknown;
    if (path[0] != 0x80000000 + 44)
        return unknown;
    if (path[1] != 0x80000000 + (0, utils_1.slip44ByCoin)("Solana"))
        return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000)
        return unknown;
    if (path[3] !== 0x80000000 + 0)
        return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Solana Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Solana",
        isKnown: true,
    };
}
// The standard BIP44 derivation path for Solana is: m/44'/501'/<account>'/0'
// https://github.com/solana-labs/solana/blob/master/clap-v3-utils/src/keygen/derivation_path.rs#L7
function solanaGetAccountPaths(msg) {
    const slip44 = (0, utils_1.slip44ByCoin)("Solana");
    return [{ addressNList: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + msg.accountIdx, 0x80000000 + 0] }];
}
// Solana uses the Ed25519 elliptic curve for cryptographic operations, which requires all levels of the derivation path to be hardened.
function solanaAddressNListToBIP32(addressNList) {
    return (0, utils_1.addressNListToBIP32)((0, utils_1.ed25519Path)(addressNList));
}
function toTransactionInstructions(instructions) {
    return instructions.map((instruction) => new web3_js_1.TransactionInstruction({
        keys: instruction.keys.map((key) => Object.assign(key, { pubkey: new web3_js_1.PublicKey(key.pubkey) })),
        programId: new web3_js_1.PublicKey(instruction.programId),
        data: instruction.data,
    }));
}
function solanaBuildTransaction(msg, address) {
    var _a, _b;
    const instructions = toTransactionInstructions((_a = msg.instructions) !== null && _a !== void 0 ? _a : []);
    const value = Number(msg.value);
    if (!isNaN(value) && value > 0 && msg.to) {
        instructions.push(web3_js_1.SystemProgram.transfer({
            fromPubkey: new web3_js_1.PublicKey(address),
            toPubkey: new web3_js_1.PublicKey(msg.to),
            lamports: value,
        }));
    }
    if (msg.computeUnitLimit !== undefined) {
        instructions.push(web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({ units: msg.computeUnitLimit }));
    }
    if (msg.computeUnitPrice !== undefined) {
        instructions.push(web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: msg.computeUnitPrice }));
    }
    const addressLookupTableAccounts = (_b = msg.addressLookupTableAccountInfos) === null || _b === void 0 ? void 0 : _b.map((accountInfo) => {
        return new web3_js_1.AddressLookupTableAccount({
            key: new web3_js_1.PublicKey(accountInfo.key),
            state: web3_js_1.AddressLookupTableAccount.deserialize(new Uint8Array(accountInfo.data)),
        });
    });
    const message = new web3_js_1.TransactionMessage({
        payerKey: new web3_js_1.PublicKey(address),
        instructions,
        recentBlockhash: msg.blockHash,
    }).compileToV0Message(addressLookupTableAccounts);
    return new web3_js_1.VersionedTransaction(message);
}
//# sourceMappingURL=solana.js.map